import { configureStore } from "@reduxjs/toolkit";
import empReducer from './emp'

export const store = configureStore({
    reducer: {
        emp: empReducer,
    }
})